import { makeStyles } from '@material-ui/core/styles';

import f1Logo from '../../../../images/retention/F1_Logo.svg';
import proLogo from '../../../../images/retention/TV_Pro.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('lg')]: {
      width: '552px',
    },
  },
  logo: {
    maxWidth: '179px',
    maxHeight: '20px',
  },
}));

const RetentionLogo = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.logo}>
        <img alt="f1logo" src={f1Logo} />
        <img alt="prologo" src={proLogo} />
      </span>
    </div>
  );
};

export default RetentionLogo;
